export const CaptchaErrorCode = {
  INVALID: { message: 'invalid captcha' },
  MISSING: { message: 'missing captcha' },
};
